/**
 * @author Mr_FabiozZz[mr.fabiozzz@gmail.com]
 */
import React, { useContext, useEffect, useMemo, useRef, useState } from "react";
import sass from "./listOfBasic.module.sass";
import PortalWrapper from "components-new/PortalWrapper";
import { Button } from "components/shared";
import { BUTTON_VARIANTS } from "components/shared/Button/Button";
import { CreateContext } from "pages/StepPages/StepFour/One/Tables/Tables";
import { useOutsideAlerter } from "hooks/useOutsideAlerter";
import DropMenu from "pages/StepPages/StepFour/One/Tables/TableNavigate/DropMenu";
import { fetchTacticTableData } from "pages/StepPages/StepFour/One/Tables/fetch";
import { useParams } from "react-router-dom";
import { ReactComponent as LoadingIcon } from "images/load.svg";

import parentSass from "pages/StepPages/StepFour/One/Tables/TableNavigate/nav.module.sass";
import { ChangeActiveTabContext } from "../TableNavigate";
import { BasicTacticResponse } from "libs/apiClient/data-contracts";

const ListOfBasicTable = () => {
	const { container, currentThread, selectFile, checkTables } = useContext(CreateContext);
	const { updateTabs } = useContext(ChangeActiveTabContext);

	const [data, setData] = useState<BasicTacticResponse[]>([]);
	const [load, setLoad] = useState(false);

	const params = useParams();

	useEffect(() => {
		setLoad(true);
		fetchTacticTableData(Number(params.threadId))
			.then((tactic) => {
				setData(tactic);
				setLoad(false);
				updateTabs("TACTIC");
			})
			.catch(() => setLoad(false));
		//eslint-disable-next-line
	}, []);

	const [target, setTarget] = useState<HTMLOrSVGElement | undefined>();

	useOutsideAlerter(target, () => setTarget(undefined));
	const ref = useRef<HTMLInputElement>(null);

	const render = useMemo(() => {
		const temp: { [key: string]: any } = {};
		data.forEach((_) => {
			if (temp[_.number]) {
				temp[_.number].push(_);
			} else {
				temp[_.number] = [_];
			}
		});
		let arrResult: { name: string; fields: { type: string; influence: string; id: number }[] }[] = [];
		let tempKey: any;
		for (tempKey in temp) {
			arrResult.push({
				name: tempKey,
				fields: temp[tempKey],
			});
		}
		return arrResult;
	}, [data]);

	return (
		<div className={sass.wrapper}>
			<DropMenu click={() => {}} target={target} />

			{container.current && (
				<PortalWrapper containerRef={container.current}>
					<input
						ref={ref}
						accept={".docx, application/pdf"}
						onChange={(e) => {
							selectFile(e);
						}}
						id={"file"}
						type={"file"}
						disabled={currentThread?.threatStatus === "APPROVED"}
						hidden={true}
					/>
					<Button
						onClick={() => {
							checkTables({
								type: "model",
								ok: () => {
									ref.current?.click();
								},
							});
						}}
						disabled={currentThread?.threatStatus === "APPROVED"}
						variant={BUTTON_VARIANTS.OUTLINED}>
						Загрузить утвержденный документ
					</Button>
				</PortalWrapper>
			)}
			<div className={sass.sticky}>
				<div className={sass.caption}>
					Таблица 8 – Перечень основных тактик и соответствующих им типовых техник,
					<br />
					используемых для построения сценариев реализации угроз безопасности информации
				</div>
				<table>
					<thead>
						<tr>
							<th>Номер</th>
							<th>Тактика</th>
							<th>Основные техники</th>
							{/*<th/>*/}
						</tr>
					</thead>
				</table>
			</div>
			<div data-comment-false={true} className={sass.scroll_wrapper}>
				{load ? (
					<LoadingIcon width={50} height={50} className={parentSass.loading} />
				) : (
					<div className={sass.scroll}>
						<table>
							<tbody>
								{render.map((_: any, index) => {
									return (
										<React.Fragment key={index}>
											<tr>
												<td rowSpan={_.fields.length}>{_.fields[0].number}</td>
												<td rowSpan={_.fields.length}>{_.fields[0].tactic}</td>
												<td>{_.fields[0].technic}</td>
											</tr>
											{_.fields.map((item: any, rowIndex: number) => {
												if (rowIndex !== 0) {
													return (
														<tr key={rowIndex}>
															<td>{item.technic}</td>
														</tr>
													);
												}
												return null;
											})}
										</React.Fragment>
									);
								})}
							</tbody>
						</table>
					</div>
				)}
			</div>
		</div>
	);
};

export default ListOfBasicTable;
